import {
  WomBasketCreateRequest,
  WomBasketCreateResponse,
  WomBasketBaseRequest,
  WomBasketBaseResponse,
  WomBasketListResponse,
  WomBasketListRequest,
} from './womBasket.types';
import { API_BASE_URL } from '..';
import instance from '@/api/axiosInstance';
import { getUserFromLocalStorage } from '@/utils/user';
import OAuth from '@/core/libs/OAuth/OAuth.class';

const CONTROLLER = `${API_BASE_URL}/basket`;

type CredentialTokens = { access_token?: string };

export default {
  async createBasket(data: WomBasketCreateRequest) {
    const { accessToken } = getUserFromLocalStorage();
    const womTokenJson = OAuth.getCredentialTokens<CredentialTokens>('WOM');
    const womToken = womTokenJson?.access_token;

    const response = await instance.post<
      WomBasketCreateResponse,
      WomBasketCreateResponse
    >(CONTROLLER, data, {
      headers: {
        'WOM-TOKEN': `Bearer ${womToken}`,
        Authorization: accessToken ? `Bearer ${accessToken}` : '',
      },
    });

    return response;
  },

  async deleteBasket(workOrderComplementId: number) {
    const { accessToken } = getUserFromLocalStorage();
    const womTokenJson = OAuth.getCredentialTokens<CredentialTokens>('WOM');
    const womToken = womTokenJson?.access_token;

    const response = await instance.delete<void, void>(
      `${CONTROLLER}/${workOrderComplementId}`,
      {
        headers: {
          'WOM-TOKEN': `Bearer ${womToken}`,
          Authorization: accessToken ? `Bearer ${accessToken}` : '',
        },
      },
    );

    return response;
  },

  async updateBasket({
    workOrderComplementId,
    ...params
  }: WomBasketBaseRequest) {
    const { accessToken } = getUserFromLocalStorage();
    const womTokenJson = OAuth.getCredentialTokens<CredentialTokens>('WOM');
    const womToken = womTokenJson?.access_token;

    const response = await instance.put<
      WomBasketBaseResponse,
      WomBasketBaseResponse
    >(`${CONTROLLER}/${workOrderComplementId}`, {
      params,
      headers: {
        'WOM-TOKEN': `Bearer ${womToken}`,
        Authorization: accessToken ? `Bearer ${accessToken}` : '',
      },
    });

    return response;
  },

  async detailBasket(workOrderComplementId?: number) {
    const { accessToken } = getUserFromLocalStorage();
    const womTokenJson = OAuth.getCredentialTokens<CredentialTokens>('WOM');
    const womToken = womTokenJson?.access_token;

    const response = await instance.get<
      WomBasketBaseResponse,
      WomBasketBaseResponse
    >(`${CONTROLLER}/${workOrderComplementId}`, {
      headers: {
        'WOM-TOKEN': `Bearer ${womToken}`,
        Authorization: accessToken ? `Bearer ${accessToken}` : '',
      },
    });

    return response;
  },

  async listBasket(params?: WomBasketListRequest) {
    const { accessToken } = getUserFromLocalStorage();
    const womTokenJson = OAuth.getCredentialTokens<CredentialTokens>('WOM');
    const womToken = womTokenJson?.access_token;

    const response = await instance.get<
      WomBasketListResponse,
      WomBasketListResponse
    >(`${CONTROLLER}/filter`, {
      params,
      headers: {
        'WOM-TOKEN': `Bearer ${womToken}`,
        Authorization: accessToken ? `Bearer ${accessToken}` : '',
      },
    });

    return response;
  },
};
